import { getAvailableConnectors, useApiQuery } from '@hum/api';
import { Result } from '@hum/common';

export const useAvailableConnectors = () => {
  const { data: availableConnectors, isLoading } = useApiQuery(
    getAvailableConnectors
  );

  return { data: availableConnectors, loaded: !isLoading } as Result<string[]>;
};
